import { cn } from '@/shared/lib/cn';

// Feld-Herkunft sichtbar machen (3-Layer-Truth): woher stammen die Daten einer Karte?
// Das ist der Differenzierer ggue. generischen Inboxen — Staff sieht sofort, ob eine
// Telefonnummer die echte (vom Gast) oder ein OTA-Alias ist.
export type Provenance = 'guest' | 'ota' | 'internal' | 'gated';

const STYLES: Record<Provenance, { label: string; cls: string }> = {
  guest: { label: 'Vom Gast', cls: 'bg-sage/15 text-sage' },
  ota: { label: 'OTA', cls: 'bg-amber/20 text-[#9a6f1e]' },
  internal: { label: 'Stammdaten', cls: 'bg-sage/15 text-sage' },
  gated: { label: 'Gastportal', cls: 'bg-line/60 text-ink-faint' },
};

export function ProvenanceTag({ source }: { source: Provenance }) {
  const s = STYLES[source];
  return (
    <span
      className={cn(
        'rounded-pill inline-flex items-center px-2 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.04em]',
        s.cls,
      )}
    >
      {s.label}
    </span>
  );
}
